import request from '@/utils/request'

/*
 * 查询资源列表（软文，微信，微博，网红，短视频）
 * type(news/woa/weibo/live/video)
 */
export function fetchResource (type, params) {
  return request.request(
    `/resource/${type}`,
    params,
    {method: 'get'}
  )
}

/*
 *  加入购物车
 */
export function addToCart (resourceId, type, top) {
  return request.request(
    `/cart`,
    {
      resource_id: resourceId,
      taxonomy: type,
      type: top
    },
    {method: 'POST'}
  )
}

/*
 *  从购物车中删除
 */
export function deleteFromCart (cartId) {
  return request.request(
    `/cart/${cartId}`,
    {},
    {method: 'DELETE'}
  )
}

/*
 *  查询资源详情
 */
export function fetchResourceDetail (type, id) {
  return request.request(
    `/resource/${type}/${id}`,
    {},
    {method: 'get'}
  )
}

/*
 *  加入收藏
 */
export function addToCollection (resourceId, type) {
  return request.request(
    `/collection`,
    {
      resource_id: resourceId,
      taxonomy: type
    },
    {method: 'POST'}
  )
}

/*
 *  从收藏中删除
 */
export function deleteFromCollection (collectionId) {
  return request.request(
    `/collection/${collectionId}`,
    {},
    {method: 'DELETE'}
  )
}

/*
 *  查询相关文章
 */
export function getRelatedArticles (accountId, taxonomy, limit) {
  return request.request(
    `/resource/release?m=article&account_id=${accountId}&taxonomy=${taxonomy}&limit=${limit}&format=plain`,
    {},
    {method: 'GET'}
  )
}



// WEBPACK FOOTER //
// ./src/api/resource.js